<template>
  <div class="spinner-wrapper" :style="wrapperStyles">
    <div class="spinner" :style="spinnerStyles">
      <div class="spinner-circle" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: Number,
      default: 100,
    },
    color: {
      type: String,
      default: null,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapperStyles() {
      return {
        width: this.centered ? '100%' : `${this.size}px`,
        height: this.centered ? '100%' : `${this.size}px`,
        display: this.centered ? 'flex' : 'inline-block',
        justifyContent: this.centered ? 'center' : 'normal',
        alignItems: this.centered ? 'center' : 'normal',
      };
    },
    spinnerStyles() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderColor: this.color || 'var(--primary)',
        borderTopColor: 'transparent',
      };
    },
  },
};
</script>

<style scoped>
.spinner-wrapper {
  position: relative;
}

.spinner {
  display: inline-block;
  border-radius: 50%;
  border-width: 4px;
  border-style: solid;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
